import { Input } from 'antd';
import React from 'react';

const MASK = '+38 (___) ___-__-__';
const DIGITS_COUNT = 10;

const applyMask = (digits: string): string => {
  let result = '';
  let digitIndex = 0;

  for (let i = 0; i < MASK.length; i++) {
    if (digitIndex >= digits.length) break;
    if (MASK[i] === '_') {
      result += digits[digitIndex++];
    } else {
      result += MASK[i];
    }
  }

  return result;
};

const extractDigits = (value: string): string => {
  const all = value.replace(/\D/g, '');
  const digits = all.startsWith('38') ? all.slice(2) : all;
  return digits.slice(0, DIGITS_COUNT);
};

interface Props {
  value?: string;
  onChange?: (value: string) => void;
}

const PhoneMaskInput: React.FC<Props> = ({ value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = extractDigits(e.target.value);
    onChange?.(applyMask(digits));
  };

  return (
    <Input
      value={value ?? ''}
      onChange={handleChange}
      placeholder={MASK.replace(/_/g, '0')}
      maxLength={MASK.length}
    />
  );
};

export default PhoneMaskInput;
